import React, { useMemo } from "react";
import { FilterValueSelect } from "Components/Common/TableFilters";

type LevelFilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const LevelFilter = ({ onChange, value }: LevelFilterProps) => {
  const options = useMemo(() => {
    return [
      {
        value: 0,
        label: "0",
      },
      {
        value: 1,
        label: "1",
      },
      {
        value: 2,
        label: "2",
      },
    ];
  }, []);

  return (
    <FilterValueSelect
      id="levelFilter"
      placeholder="Select level"
      value={value}
      onChange={onChange}
      options={options}
    />
  );
};

export default LevelFilter;
